import React, { Component } from 'react';
import { connect } from 'react-redux';
import './NewBrowserSelection.css';
import Header from '../SubComponents/Header/Header';

const mapStateToProps = (state) => {
  return {
    languageObj: state.language.new_browser_selection_js,
  };
}

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(class BrowserSelection extends Component {
  render() {
    return (
      <div className={'AppContainer'}>
        <Header
          header={this.props.languageObj.render.header}
          subHeader={this.props.languageObj.render.sub_header}
          slogan={this.props.languageObj.render.slogan}
          classNames={'Header-bottom'}
        />
        <div className={'BrowserContainer'}>
          <div>
            {this.props.languageObj.render.browser_container_pre}
            <br /> {this.props.languageObj.render.browser_container_post}
          </div>
          <div className={'Browser-Button-Container'}>
            <a href={'https://www.google.com/chrome/'} className={'Browser-Link'}>
              <div className={'Browser-button'}>
                <p>
                  {this.props.languageObj.render.google_chrome}
                </p>
                <img
                  alt={'Google Chrome'}
                  src={'http://icons.iconarchive.com/icons/google/chrome/128/Google-Chrome-icon.png'}
                  width={100}
                />
              </div>
            </a>
            <a href={'https://www.mozilla.org/en-US/firefox/new/'} className={'Browser-Link'}>
              <div className={'Browser-button'}>
                <p>
                  {this.props.languageObj.render.firefox}
                </p>
                <img
                  alt={'Firefox'}
                  src={'http://icons.iconarchive.com/icons/carlosjj/mozilla/128/Firefox-icon.png'}
                  width={100}
                />
              </div>
            </a>
          </div>
        </div>
      </div>
    );
  }
});
